import { render } from "./MessageList.vue?vue&type=template&id=c650a9aa&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=c650a9aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c650a9aa"]])

export default __exports__